import { updateWorkoutPreference } from "../../api/wokoutPreferenceApi";
import * as Endpoints from "../../entities/Endpoints";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const updatePostWorkoutPreferenceThunk = createAsyncThunk(
  Endpoints.UPDATE_WORKOUT_PREFERENCE,
  async ({ workoutPreferenceData }, { rejectWithValue }) => {
    try {
      const data = await updateWorkoutPreference({ workoutPreferenceData });
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update workout preference"
      );
    }
  }
);

const workoutPostPreferenceSlice = createSlice({
  name: "postWorkoutPreference",
  initialState: {
    workoutPreferencePost: null,
    isloading: false,
    error: null,
    successMessage: null,
    updateSuccessMessage: "",
    updateFailedMessage: "",
  },
  reducers: {
    clearUpdateMessage: (state) => {
      state.updateSuccessMessage = "";
      state.updateFailedMessage = "";
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(updatePostWorkoutPreferenceThunk.pending, (state) => {
        state.isloading = true;
        state.error = null;
      })
      .addCase(updatePostWorkoutPreferenceThunk.fulfilled, (state, action) => {
        state.isloading = false;
        state.workoutPreferencePost = action.payload;
        state.updateSuccessMessage = " Workout preference changed.";
      })
      .addCase(updatePostWorkoutPreferenceThunk.rejected, (state, action) => {
        state.isloading = false;
        state.error = action.payload;
        state.updateFailedMessage =
          action.payload || "Failed to change workout preference.";
      });
  },
});

export const { clearUpdateMessage } = workoutPostPreferenceSlice.actions;

export default workoutPostPreferenceSlice.reducer;
